import "./AboutPage.scss"

const AboutPage = () => {
    return (
        <div style={{display: "flex", flexDirection: "column", textAlign: "center", justifyContent: "start"}} className="container agreement">
            <h3 style={{textAlign: "center", margin: "90px 0 20px"}}>Про нас</h3>
            <div style={{marginBottom: "10px"}}>
                <b>DayZ Standalone</b> — це хардкорна гра, де гравцям потрібно виживати у постапокаліптичному світі, населеному зомбі та іншими людьми, що вижили. У грі є оригінальна карта "Чернорусь" та додаткова "Лівонія".
                Дізнатися більше або придбати гру можна <a className="dayz-steam-link" target="_blank" href="https://store.steampowered.com/app/221100/DayZ/">тут</a>.
            </div>
            <div style={{marginBottom: "10px"}}>
                <b>Askold DayZ</b> — це український проект, створений фанатами гри DayZ Standalone. Проект був запущений у грудні 2024 року для реалізації унікального бачення цієї улюбленої гри.
            </div>
            <div style={{marginBottom: "10px"}}>
                На наших серверах доступні такі <b>модифікації</b>, як паті-мод, карта, спеціальні кімнати з цінним лутом, розширене будівництво, електронний замок, збалансована модифікована зброя, власна фурнітура та багато іншого. Дізнатися більше можна <a className="dayz-steam-link" target="_blank" href="https://discord.gg/EJYZ37Pa">тут</a>.
            </div>
            <div style={{marginBottom: "10px"}}>
                Розробка власних модифікацій та майже цілодобове адміністрування потребує значних ресурсів. Тому всі кошти, які ви витрачаєте, будуть направлені на підтримку та розвиток нашого проекту.
            </div>
            <div className="DSAL-block">
                <p>Якщо у вас вже є <b>ліцензійна версія</b> гри, ви можете підключитісь через стандартний лаунчер до наших серверів або через <b>DayZSA Launcher</b></p>
                <a className="button-buy" href="https://dayzsalauncher.com/releases/setup_dzsalauncher-0.0.5.7.exe">Скачати DayZSA Launcher</a>
            </div>
            <img className="about-img" src="https://i.imgur.com/5Edg6qJ.png" alt="img"/>
        </div>
    );
};

export default AboutPage;